import React, { useEffect } from 'react';
import './Privacy.css';

const Terms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='px-4 py-6 md:px-8 lg:px-12 md:py-8 bg-black text-white max-w-4xl mx-auto'>
            <div className='h-48 sm:h-56 md:h-64 mb-10 flex flex-col justify-center items-center bg-gradient-to-r  rounded-lg shadow-lg'>
                <p className='text-white text-2xl sm:text-3xl md:text-4xl font-extrabold text-center px-4  text-center text-white text-lg sm:text-xl md:text-xl font-semibold -mt-4 mb-4 bg-gradient-to-r from-gold1 to-yellow-350 p-6 rounded-xl shadow-lg transform hover:scale-105 transition duration-300 ease-in-out max-w-lg mx-auto'>
                    Terms Of Use
                </p>
            </div>
            <section className='text-justify leading-relaxed'>
                <p className='text-base sm:text-lg md:text-xl mt-2'>
                    Welcome to Shambhuraj Khamkar's Trading Academy ("SKTA," "we," "us," or "our")! These Terms of Use ("Terms") govern your access to and use of our website, learn.skta.in (the "Website"), and the services offered thereon (the "Services").
                </p>
                <p className='text-base sm:text-lg md:text-xl mt-4'>
                    By accessing or using the Website or Services, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access or use the Website or Services.
                </p>
            </section>
            {[
                { title: "1. Use of the Website and Services", content: [
                    "You must be at least 18 years old to access or use the Website or Services.",
                    "You are responsible for maintaining the confidentiality of your account information and password.",
                    "You may not use the Website or Services for any illegal or unauthorized purpose.",
                    "You may not damage, disable, or overburden the Website or Services, or interfere with others' enjoyment.",
                    "You may not access the Website or Services through automated means without our permission."
                ]},
                { title: "2. Intellectual Property", content: [
                    "The Website and Services contain intellectual property belonging to SKTA, including trademarks, copyrights, and other proprietary information."
                ]},
                { title: "3. User Content", content: [
                    "You may submit content (text, images, videos, etc.) to the Website or Services ('User Content'). You retain ownership rights to your User Content, but grant SKTA a non-exclusive, royalty-free, worldwide license to use and distribute it."
                ]},
                { title: "4. Disclaimers", content: [
                    "The information on the Website and Services is for informational purposes only and does not constitute financial advice. The Website and Services are provided 'as is' without warranties of any kind."
                ]},
                { title: "5. Limitation of Liability", content: [
                    "SKTA's liability is limited to the amount you paid for the Services."
                ]},
                { title: "6. Termination", content: [
                    "We may terminate your access to the Website or Services at any time, without notice."
                ]},
                { title: "7. Governing Law", content: [
                    "These Terms are governed by the laws of India."
                ]},
                { title: "8. Entire Agreement", content: [
                    "These Terms constitute the entire agreement between you and SKTA regarding the use of the Website and Services."
                ]},
                { title: "9. Changes to the Terms", content: [
                    "We may update these Terms from time to time. Any changes will be posted on the Website."
                ]},
                { title: "10. Contact Us", content: [
                    "If you have any questions about these Terms, please contact us at 9822500374."
                ]}
            ].map((section, index) => (
                <section key={index} className='mt-8'>
                    <p className='text-lg sm:text-xl md:text-2xl font-semibold'>
                        {section.title}
                    </p>
                    {section.content.map((text, idx) => (
                        <p key={idx} className='text-base sm:text-lg md:text-xl mt-2 leading-relaxed text-justify'>
                            {text}
                        </p>
                    ))}
                </section>
            ))}
        </div>
    );
};

export default Terms;
